import "../../sass/components/CookiePopup.scss";
import {ButtonPrimary} from "@/Components/Buttons/ButtonPrimary";
import {deleteCookies} from "@/Utilities/CookieManager";

export default function CookiePopup({setShowCookiePopup, setCookie}) {

    return (
        <div className="cookie-popup-container">
            <div className="cookie-popup-content">
                <div className="cookie-text">
                    By clicking “Accept Cookies”, you agree to the storing of cookies on your device to enhance site navigation,
                    analyze site usage, and assist in our marketing efforts. For more information, please refer to our&nbsp;
                    <a href="https://legal.ministrybrands.com/#privacy-policy" target="_blank">Privacy Policy</a>.
                </div>
                <div className="cookie-actions">
                    <ButtonPrimary onClick={() => {
                        setCookie("cookieConsent", true, 365);
                        setShowCookiePopup(false);
                    }}>Accept Cookies</ButtonPrimary>
                    <ButtonPrimary className="reject" onClick={() => {
                        deleteCookies();
                        setShowCookiePopup(false);
                    }}>Reject Cookies</ButtonPrimary>
                </div>
            </div>
            <i onClick={() => setShowCookiePopup(false)} className="fa fa-times"></i>
        </div>
    )
}
